import React from 'react';
import createReactClass from 'create-react-class';
import request from '../../helpers/request';
import itemConfig from './config/itemConfig';
import setViewTitle from '../../helpers/setViewTitle';
import storagelocationConfig from '../storagelocations/config/storagelocationConfig';
import SimplePage from '../common/SimplePage';
import { Form, Input, FormRow, FormsySelect } from '../common/Forms';
import AjaxInProgressHOC from '../common/AjaxInProgressHOC';

var NewItem = createReactClass({

  componentWillMount() {
    setViewTitle('Neuer Artikel');
  },

  componentDidMount() {
    this.form.focusAndSelect('name');
  },

  submitForm(newItem) {
    request.post({
      url: itemConfig.apiUrl,
      data: newItem,
      success: itemId => {
        this.props.history.push(`/items/${itemId}/vendors`);
      }
    });
  },

  render() {
    return (
      <SimplePage title="Neuer Artikel" icon="cubes">
        <Form ref={c => this.form = c}
          onSubmit={this.submitForm}
          isAjaxInProgress={this.props.isAjaxInProgress}
          backButtonLink="/items">

          <fieldset>
            <FormRow width={6}>
              <Input
                layout="vertical"
                name="name"
                id="name"
                label="Name:"
                type="text"
                value="Neuer Artikel"
                required
              />
            </FormRow>

            <FormRow width={6}>
              <FormsySelect
                layout="vertical"
                name="defaultStorageLocationId"
                id="defaultStorageLocationId"
                label="Lagerort:"
                type="text"
                dataUrl={storagelocationConfig.fastSearchUrl}
                onSelect={this.handleStorageLocationSelect}
                searchPlaceholder="Lagerort auswählen"
                idProp="id"
                displayProp="name"
                inputTooShortText="Geben Sie mind. 2 Zeichen ein"
                noMatchesText="Kein Ergebnis"
                searchInProgressText="Suche..."
                required
              />
            </FormRow>

            <FormRow width={6}>
              <Input
                layout="vertical"
                name="defaultStorageBinName"
                id="defaultStorageBinName"
                label="Lagerplatz:"
                type="text"
                value=""
                required
              />
            </FormRow>

            <FormRow width={6}>
              <Input
                layout="vertical"
                name="stockUnit"
                id="stockUnit"
                label="Basiseinheit:"
                type="text"
                value="Stück"
                required
              />
            </FormRow>

            <FormRow width={6}>
              <Input
                layout="vertical"
                name="lowStockLimit"
                id="lowStockLimit"
                label="Mindestmenge:"
                type="number"
                value={1}
                validations="isMoreThan:0"
                validationErrors={{
                  isMoreThan: 'Die Mindestmenge muss größer 0 sein.',
                }}
                required
              />
            </FormRow>

          </fieldset>
        </Form>
      </SimplePage>
    );
  }

});

export default AjaxInProgressHOC(NewItem);



// WEBPACK FOOTER //
// ./src/components/items/NewItem.js